import { DataComponentType, MarketsComponentType } from '@/types/markets';

export const parseMarketComponent = (
  component: DataComponentType,
  version = '1'
): MarketsComponentType => {
  const temp = { ...(component as any) };

  const tabs = temp.tabs;
  const id = crypto.randomUUID();

  if (version === '1') {
    if (temp.type === 'feed') {
      return {
        layout: component.layout,
        tabs: [{ name: 'Feed', ...component }] as any,
        id: crypto.randomUUID()
      };
    }
    if (temp.type === 'file_list') {
      return {
        layout: component.layout,
        tabs: [{ ...temp, name: temp.name ?? 'Data lake files' }],
        id
      };
    }
    if (tabs) {
      const tt = tabs.map((item: any) => {
        return { ...item, ...component };
      });

      return { layout: component.layout, tabs: tt, id: crypto.randomUUID() };
    }
  }

  if (temp.type === 'tiles') {
    return { layout: component.layout, component: temp, id: crypto.randomUUID() };
  }

  if (Array.isArray(tabs)) {
    return { layout: component.layout, tabs, id };
  }

  // When tabs are not present,
  return { layout: component.layout, tabs: [{ ...temp, name: temp.name ?? '' }], id };
};
